import { render } from "./Indicator.vue?vue&type=template&id=44eb8d3e"
import script from "./Indicator.vue?vue&type=script&setup=true&lang=js"
export * from "./Indicator.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Products/Table/Indicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44eb8d3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44eb8d3e', __exports__)) {
    api.reload('44eb8d3e', __exports__)
  }
  
  module.hot.accept("./Indicator.vue?vue&type=template&id=44eb8d3e", () => {
    api.rerender('44eb8d3e', render)
  })

}


export default __exports__